import type { UseMutationResult } from '@tanstack/react-query'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { COMMENT_API_PREFIX } from 'shared/api/constants/api-constants'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseMutationClearOptions } from 'shared/types/tanstack-utility-types'
import { commentsKeys } from 'modules/comments/api/key-factory'
import { CommentsTypeEnum } from 'modules/comments/types'

interface UseUnpinCommentOptions extends UseMutationClearOptions<void, Error, void> {
  commentId: number
  pageId: number
}

export const useUnpinComment = ({
  commentId,
  pageId,
  ...options
}: UseUnpinCommentOptions): UseMutationResult<void, Error, void> => {
  const queryClient = useQueryClient()
  const { fetcher } = useApiWrapperWithErrorValidation<RequestMethodsEnum.delete, void, void>({
    method: RequestMethodsEnum.delete,
    notFoundResponseHandler() {},
  })

  return useMutation({
    mutationFn: async () => fetcher(`${COMMENT_API_PREFIX}/${commentId}/pin`),
    ...options,
    onSuccess: async (...args) => {
      await options.onSuccess?.(...args)
      await queryClient.invalidateQueries({
        queryKey: commentsKeys.resource(CommentsTypeEnum.Community, pageId),
      })
    },
  })
}
